import React from 'react';
import style from '../css/WhatWeOffer.module.css';

const offerings = [
	{
		title: 'Private Jet Charters',
		description:
			'Experience the pinnacle of convenience and comfort with our private jet charters.',
		tags: ['luxurious seating', 'privacy'],
	},
	{
		title: 'Every Detail Effortlessly',
		description:
			'Stay in luxurious, handpicked accommodations at stunning global locations.',
		tags: ['Dining', 'Activities'],
	},
	{
		title: 'Lifetime Adventures.',
		description:
			'Unlock access to unique and exclusive experiences that few can offer.',
		tags: ['Wildlife safari', 'Museum visit'],
	},
	{
		title: 'Luxury Accommodations',
		description:
			'Our handpicked luxury accommodations range from opulent five-star hotels to exclusive private villas.',
		tags: ['Stunning views', 'Top-tier amenities'],
	},
];

function WhatWeOffer() {
	return (
		<section className={style.container}>
			<h2>What We Offer</h2>
			<div className={style.cardGrid}>
				{offerings.map((item, i) => (
					<div key={i} className={style.card}>
						<div className={style.cardHeader}>
							<h3>{item.title}</h3>
							{/* <span className={style.arrow}>&#8594;</span> */}
						</div>
						<p>{item.description}</p>
						<div className={style.tags}>
							{item.tags.map((tag, j) => (
								<span key={j} className={style.tag}>
									{tag}
								</span>
							))}
						</div>
					</div>
				))}
			</div>
		</section>
	);
}

export default WhatWeOffer;
